const loadAndInitThree = async (
  container: HTMLElement,
  objectName: string
): Promise<any> => {
  if (container.dataset.initialized === 'true') return;
  container.dataset.initialized = 'true';

  const loadingP = container.querySelector<HTMLElement>(
    '[data-3d-container-loading]'
  );

  const idle = (cb: () => void) =>
    'requestIdleCallback' in window
      ? (window as any).requestIdleCallback(cb, { timeout: 1500 })
      : setTimeout(cb, 0);
  await new Promise<void>((resolve) => idle(resolve));

  const onThreeReady = () => loadingP?.remove();
  container.addEventListener('three-ready', onThreeReady, { once: true });

  const tryRemoveOnCanvas = () => {
    const hasCanvas = container.querySelector('canvas');
    if (hasCanvas) {
      requestAnimationFrame(() => loadingP?.remove());
      mo.disconnect();
    }
  };
  const mo = new MutationObserver(tryRemoveOnCanvas);
  mo.observe(container, { childList: true, subtree: true });
  tryRemoveOnCanvas();

  try {
    const [{ initThree }, modelUrl] = await Promise.all([
      import('./theeJS'),
      (async () => {
        switch (objectName) {
          case 'protein-structure':
            return (await import('../assets/3d-files/protein-structure.glb'))
              .default;
          case 'iphone':
            return (await import('../assets/3d-files/iPhone.glb')).default;
          default:
            throw new Error(`Unknown 3D object name: ${objectName}`);
        }
      })(),
    ]);

    const options = {
      debug: false,
      forceMaterial: 'none' as const,
      doubleSided: false,
      wireframe: false,
      assumeUnits: 'cm' as const,
      axisFix: 'none' as const,

      pixelRatioCap: Math.min(window.devicePixelRatio || 1, 1.5),
      antialias: false,
      powerPreference: 'low-power' as const,

      onReady: () => {
        loadingP?.remove();
        container.dispatchEvent(new Event('three-ready'));
      },
      onError: () => {
        if (loadingP) loadingP.textContent = 'Failed to load. Tap to retry.';
      },
      onContextLost: () => {
        if (loadingP) loadingP.textContent = 'Graphics error. Tap to reload.';
      },
    };

    initThree(container, modelUrl, options);
  } catch (err) {
    console.warn(err);
    if (loadingP) loadingP.textContent = 'Failed to load. Tap to retry.';
    container.dataset.initialized = 'false';
  }

  container.addEventListener(
    'click',
    () => {
      if (container.dataset.initialized !== 'true') {
        loadAndInitThree(container, objectName);
      }
    },
    { once: true }
  );
};

export default loadAndInitThree;
